import { render, staticRenderFns } from "./RealEstate-fr.vue?vue&type=template&id=1b4b2a09&scoped=true&"
import script from "./RealEstate-fr.vue?vue&type=script&lang=js&"
export * from "./RealEstate-fr.vue?vue&type=script&lang=js&"
import style0 from "./RealEstate-fr.vue?vue&type=style&index=0&id=1b4b2a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b2a09",
  null
  
)

export default component.exports